var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('WorkEnvReportItemPie',{attrs:{"question":"22. ¿Has vivido alguna de estas situaciones en el ILSB?","answers":_vm.answers_data['q22']}}),_c('WorkEnvReportItemPie',{attrs:{"question":"23. ¿En el ILSB has vivido alguna de estas situaciones?","answers":_vm.answers_data['q23']}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }